export const prodModUserIds = [
  'P-mx2GXrH84T329KZQFEu', // uri
  '8JQIXyw9TYKtbyReVefna', // matt
  'UV_VmkIWrKQx_Ckbttqp5', // mark
  'ky8vaZYcmhuK7-tqVtYCe', // john
  'nZq5KqveuL77pmvgq_CVU', // jake
  'EUuK3vp53Gdd3vCoro-tI', // ilbum
  // 'KnvqQxhPm2w92MV129Me1', // corey
  'XkRDY7FFsSUpdldHVt6S', // chad
  'RHitwgBuHPOEhI1HepIgk', // caytie
  'q0lGi-nNnSuElytrLEn1U', // brian
  'PToUIuZ3AYkYQdegSNBn', // jorge
  'rhX_y37ByiUXuuaBWVRPP', // audie
  'xnhLglPZd3wxBzy0qLQfP', // max
  '1pCmNory8pB9bCCy5u2-s', // kayla
  'o8srFbgH7bJJlwBSLXVvU', // creative HQ
  'AXJtV2cKUo6YhecKdC4kq', // RJ
  'PSbVnOCWKzJX5AWWYOIsP', // speralta
  'luqUZ38C1YqkzdFFGJD0C', // recruiter profile
  'ftu_0I4cxfe7JsiKbSAgz', // recruiter profile
  'EFUVOxpDnaiS04fS41G_P', // recruiter profile
  'ELlAGt-2I1n5dVKKR1-TG', // recruiter profile
  'ojzeaXTlW3PpXmt-9eQHs', // recruiter profile
  '1OJ-Y5eFJAYrCYGMeggo8', // recruiter profile
  'dXsxe5gaNCchCQ4Lshl8R', // isabella castillo
]

export const stagingModUserIds = [
  'ECggFPNAOu_-qpImrOnFJ', // ilbum
  'Hb9Uf0zuguROdBuQbsWnu', // max
  't5SHcLm1uvmSdQpCkYPWE', // john
  '8a5TwAcp5ysoJsx-LxFjS', // brian
  '4tj1lwRO7s33U5G-dNw_O', // jorge
  'M9AejMNPLFpMTOsvKtvOc', // matt
]
